import { createFileRoute, Outlet } from '@tanstack/react-router'

import { SettingsPage } from '@/components/Internal/SettingsPage'

/** Every list in the group is one sheet on the same scrolling ground. */
export const Route = createFileRoute(
  '/internal/system/administration/classifications',
)({
  component: () => (
    <SettingsPage>
      <Outlet />
    </SettingsPage>
  ),
})
